import { createSelector } from 'reselect';
import { navSelector } from '.';

/**
 * @returns {( object ) => object|null} Round.
 */
export const roundSelector = createSelector(
    navSelector,
    (state) => state.rounds,
    (nav, rounds) => {
        try {
            return rounds[`season_${nav.season.id}`][`round_${nav.round.id}`];
        } catch (err) {
            return null;
        }
    }
);
